import React, { Component, PropTypes  } from 'react'
import { connect } from 'react-redux'
import { SubmissionError } from 'redux-form'
import PasswordForgetValidationForm from '../components/profile/PasswordForgetValidationForm'
import Modal from 'boron/FadeModal'
import { api, host, domen } from '../config.js'
import CSSModules from 'react-css-modules'
import styles from './profilePasswordForget.css'
import LogoLink from '../components/componentKit/LogoLink'
import {Helmet} from "react-helmet";

let contentStyle = {
  borderRadius: '18px',
  padding: '30px'
}

const defaultBg = <img className={styles.alfaBg} src="/assets/img/els/els-bg2.jpg" alt=""/>

let failMessage = 'Пользователь с таким email, не найден'
/**
 *  Контейнер ProfilePasswordForget.
 *  Используется для отображения страницы 'Восстановление пароля' (/restore)
 *
 */
class ProfilePasswordForget extends Component {
  componentWillMount() {
    if (window.mobilecheck()) {
      contentStyle.width = '300px'
    }
  }

  render() {
    const isAlfa = domen.isAlfa
    const isTele2Lk = domen.isTele2
    const isUnipro = domen.isUnipro
    let bg = defaultBg
    return (
      <div>
        <Helmet>
          <link rel="stylesheet" href="/assets/css/unipro.css" />
        </Helmet>
        <img role="presentation" id="svg-inject-me" className={styles.injectedSvg} src="assets/img/symbol-sprite.svg" alt/>
        <div className={styles.layoutEntry}>
          <div className={styles.gridEntryHeader}>
            <div className={styles.gridCellTodaymeLogo}>
              <LogoLink isUnipro={isUnipro} isAlfa={isAlfa}/>
            </div>
          </div>

          <div className={styles.entryMin}>
            <div className={styles.entryInner}>

              <div className={styles.entryHeader}>
                <h2 className={isAlfa ? styles.entryTitleCenterAlfa : styles.entryTitleCenter}>Восстановление пароля</h2>
              </div>

              <Modal ref='successModal' contentStyle={contentStyle}>
                <h2>Письмо с инструкциями отправлено на указанный вами email</h2>
              </Modal>

              <Modal ref='failModal' contentStyle={contentStyle}>
                <h2>{failMessage}</h2>
              </Modal>

              <PasswordForgetValidationForm isTele2Lk= {isTele2Lk} onSubmit={ data => {
                data.url = `${host}/restore/create`
                return fetch(`${api}/user/user-sendRestorePassword`, {
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },
                  method: 'POST',
                  body: JSON.stringify(data)
                })
                .then(response => response.json())
                .then(json => {
                  if (json.errorCode === 1 && json.data) {
                    if (json.data.resultCode === 1) {
                      this.refs.successModal.show()
                    } else {
                      failMessage = json.data.resultText
                      this.refs.failModal.show()
                    }
                  } else {
                    throw new SubmissionError({
                      password: '',
                      _error: 'Что-то пошло не так, попробуйте снова'
                    })
                  }
                })
              }}/>
            </div>
          </div>

          <div className={styles.entryBg}>
            {bg}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  program: state.profile.program,
  sign: state.sign,
  amount: state.profile.amount,
  packageType: state.profile.packageType
})

ProfilePasswordForget = connect(
  mapStateToProps,
)(ProfilePasswordForget)

export default CSSModules(ProfilePasswordForget, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/containers/ProfilePasswordForget.js